<template>
    <div class="page__about">
        <div class="page__wrapper">
            <div class="fader"></div>

            <Preloader />

            <Header />
            <section class="about page_about">
                <h1>Authorization</h1>
            </section>
        </div>
    </div>
</template>

<script>
import i18n from "../lang/lang";
import Header from "@/components/Header.vue";
import Preloader from "@/components/preloader.vue";

export default {
    ComponentName: "authorization",
    components: {
        Header,
        Preloader
    }
};
</script>

<style lang="stylus" scoped>
h1 {
    color red
}
</style>
